import AddCircleRoundedIcon from '@mui/icons-material/AddCircleRounded';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import Stack from '@mui/material/Stack';
import ProfileResetIcon from '../../HelperIcons/ProfileResetIcon';
import { ABOUT_ME_CHAR_LIMIT } from '../../../../../utils/constants';
import { StyledAccordionSummary, StyledExpandMoreIcon, TitleTypography } from './styles';


const AccordionHeader = ({
  expanded,
  setExpanded,
  panelId,
  title,
  pendingCharLimit,
  componentType,
  isAddButtonVisible,
  addBtnState,
  handleAddField,
  editBtnState,
  handleEditField,
  handleSaveFields,
  handleResetClick,
  isEditSaveToggleVisible,
}) => {

  return (
    <StyledAccordionSummary
      expandIcon={
        <div onClick={event => { event.stopPropagation(); setExpanded(expanded === panelId ? '' : panelId); }}>
          <StyledExpandMoreIcon />
        </div>
      }
      aria-controls={`${panelId}-content`}
      id={`${panelId}-header`}
      expanded={expanded === panelId ? 'true' : undefined}
    >
      
      <div style={{ flexGrow: 1, cursor: 'default' }}>
        <TitleTypography>
          {title}
          {editBtnState === 2 && componentType === "aboutMe" && (
            <span style={{ fontSize: "10px", marginLeft: "8px", ...(pendingCharLimit === 0 && { color: "red" }) }}>
              {`(${pendingCharLimit}/${ABOUT_ME_CHAR_LIMIT})`}
            </span>
          )}
        </TitleTypography>
      </div>

      <Stack direction="row" spacing={2} marginRight="15px" alignItems="center">
        {addBtnState === 2 ? (
          <CheckCircleRoundedIcon
            aria-label="tick"
            expanded={expanded === panelId ? 'true' : undefined}
            sx={{ width: '20px', height: '20px', color: '#05BC52', cursor: 'pointer', pointerEvents: 'auto' }}
            onClick={handleSaveFields}
          />
        ) : (
          isAddButtonVisible && (
            <AddCircleRoundedIcon
              aria-label="add"
              expanded={expanded === panelId ? 'true' : undefined}
              sx={{ width: '20px', height: '20px', color: addBtnState === 1 ? '#05BC52' : '#D6D8E5', cursor: addBtnState === 1 ? 'pointer' : 'auto', pointerEvents: addBtnState === 1 ? 'auto' : 'none' }}
              onClick={handleAddField}
            />
          )
        )}
        {editBtnState === 2 ? (
          <ProfileResetIcon
            aria-label="reset"
            expanded={expanded === panelId ? 'true' : undefined}
            sx={{ height: '20px', width: '20px', cursor: 'pointer', pointerEvents: 'auto' }}
            isActive={true}
            onClick={handleResetClick}
          />
        ) 
        : (
          isEditSaveToggleVisible && (
            <EditOutlinedIcon
              aria-label="edit"
              expanded={expanded === panelId ? 'true' : undefined}
              sx={{ width: '20px', height: '20px', color: editBtnState === 1 ? '#376AFA' : '#D6D8E5', cursor: editBtnState === 1 ? 'pointer' : 'auto', pointerEvents: editBtnState === 1 ? 'auto' : 'none' }}
              onClick={handleEditField}
            />
          )
        )}
      </Stack>
    </StyledAccordionSummary>
  );
};

export default AccordionHeader;
